{
  "@description": "This prod version",

  "appName": "Jerny",
  "appMode": "PROD",
  
  "comingSoon": false,

  "targetMcpUrl" : "https://api.jerny.nl/mcp",

  "@baseUrl_desc": "this is the api gateway url to krakend",
  "baseUrl": "https://api.jerny.nl",

  "@streamUrl_desc": "this is the system stream on portal",
  "streamUrl": "https://api.jerny.nl",
                                                                       
  "@gatewayStreamEndpoint_desc": "the name of gateway baseUrl, aka api.jerny.nl or direct at processing service",
  "gatewayStreamEndpoint": "https://api.jerny.nl",

  "@gatewayStreamName_desc": "the name of gateway stream endpoint name",
  "gatewayStreamName": "gatewayStream",

  "poller": {
    "intervalMs": 3000,
    "maxAttempts": 10
  }
}